export default {
  LIST_FETCHED: 'ADDRESSES_FETCHED',
  LIST_LOAD: 'ADDRESSES_LOAD',
  ITEM_DETAIL: 'ADDRESSES_DETAIL',
  BUTTON_LOAD: 'ADDRESSES_BUTTON_LOAD',
};
